<!--
 * @Author: your name
 * @Date: 2020-12-07 16:59:00
 * @LastEditTime: 2021-05-06 16:02:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/components/chat/webSocket/webSocket.vue
-->
<template>
  <div></div>
</template>

<script>
import { chatHttplogin } from "@/models/chatModel";
import { eventBus } from "@/event-bus";
import { createRandom } from "@/utils/utils";
import axios from "axios";

// const token = localStorage.getItem('token');
const WSURL = wshost;

export default {
  name: "WebSocket",
  data() {
    return {
      socket: "",
      heartBeatStatus: "send", // 心跳检测状态
      connStatus: false, // 连接状态
      reconnecting: false, // 重连状态
      textMessage: "ping",
      WSURL: WSURL,
      token: "",
      usertype: 1, // 登录类型, 1:大菠萝店铺,2:中台
      clientCode: createRandom(10), // 随机数，如果不同，之前的能收到，相同的之前收不到
      myChatId: "",
      isInvalidToken: false
    };
  },
  created() {
    this.token = localStorage.getItem("token");
    const params = {
      token: this.token,
      usertype: this.usertype
    };
    this.httplogin(params);
  },
  methods: {
    /**
     * @description: 聊天发送消息 HTTP 登录
     * @param {*}
     * @return {*}
     */
    httplogin(params) {
      chatHttplogin(params)
        .then(res => {
          // console.log("http login 成功", res);
          this.myChatId = res || "";
          localStorage.setItem("myChatId", this.myChatId);
          // this.wsInit(); // 在 indexedDB 初始化成功后再初始化 websocket
          this.heartBeat(10000);
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    /**
     * @description: 心跳检测
     * @param {*}
     * @return {*}
     */
    heartBeat(sec) {
      setInterval(() => {
        if (this.heartBeatStatus === "send") {
          // console.log("WebSocket 断线了");
          this.connStatus = false;
          if (!this.reconnecting && !this.isInvalidToken) {
            // 没有重连
            try {
              this.reconnecting = true;
              this.wsClose();
              this.wsInit();
            } catch (error) {
              console.log(error);
            } finally {
              this.reconnecting = false;
            }
          }
        } else {
          this.heartBeatStatus = "send";
          this.socket.send(this.textMessage);
        }
      }, sec);
    },
    /**
     * @description: 连接 websocket
     * @param {*}
     * @return {*}
     */
    wsInit() {
      if (typeof WebSocket == "undefined") {
        this.$notify.error("您的浏览器不支持WebSocket, 请更换浏览器，谢谢！");
        return false;
      }
      const path = `${this.WSURL}?token=${this.token}&clientCode=${this.clientCode}`;
      this.socket = new WebSocket(path);
      this.socket.onopen = this.open; // 当连接成功时
      this.socket.onmessage = this.getMessage; // 当收到消息时
      this.socket.onclose = this.wsClose; // 当链接主动断开的时候触发 close 事件
      this.socket.onerror = this.error; // 当连接失败时，触发 error 事件
    },
    /**
     * @description: ws 连接
     * @param {*}
     * @return {*}
     */
    open() {
      // console.log("open: " + this.socket.readyState);
      this.connStatus = true;
      this.heartBeatStatus = "recv";
      // this.socket.send('ping');
      sessionStorage.setItem("WSreadyState", this.socket.readyState);
    },
    /**
     * @description: 接收消息
     * @param {*}
     * @return {*}
     */
    getMessage(event) {
      // console.log("getMessage: " + this.socket.readyState, event.data);
      sessionStorage.setItem("WSreadyState", this.socket.readyState);
      if (event.data === "pong") {
        this.heartBeatStatus = "recv";
        // }else if(){
      } else {
        const msgData = JSON.parse(event.data);
        if (msgData.code == 403 || msgData.message === "token已经失效") {
          this.isInvalidToken = true;
          this.wsClose();
          return false;
        }
        if (msgData.action === "ackGroupMessage") {
          console.log("消息已签收");
          return false;
        }
        eventBus.$emit("rcdMsg", event.data); // 1. Chat 页面接收监听 2. CsNavigation/AddBox 页面接收监听
        // if (msgData.action === 'sendMsg') {
        //   eventBus.$emit('rcdMsg', JSON.stringify(msgData));
        // }
      }
    },
    /**
     * @description: 主动断开
     * @param {*}
     * @return {*}
     */
    wsClose() {
      // console.log("wsClose: " + this.socket.readyState);
      if (this.socket) {
        this.socket.close();
      }
      sessionStorage.setItem("WSreadyState", this.socket.readyState);
      // console.log("用户关闭 WebSocket");
    },
    /**
     * @description: // 当连接失败时
     * @param {*}
     * @return {*}
     */
    error() {
      // console.log("error: " + this.socket.readyState);
      sessionStorage.setItem("WSreadyState", this.socket.readyState);
      // this.$notify.error("websocket 连接失败！请退出重试！");
      // this.token = localStorage.getItem('token'); // 重新获取token
      // this.clientCode = createRandom(10); // 重新获取随机数
      // this.heartBeat(10000);
    }
  },
  destroyed() {
    if (this.socket) {
      this.socket.onclose = this.wsClose;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/chat/webSocket/webSocket.vue